angular.module('filters').filter('eventDate', function() {
  return function(input) {
    if (input) {
      return moment(input).format('h:mma, MMMM Do YYYY');
    }
  };
});
